import React, { useEffect, useState } from "react";
import styles from "./FooterSummary.module.css";

const parseFrontmatter = (mdText) => {
  const match = mdText.match(/^---\n([\s\S]*?)\n---/);
  if (!match) return { data: {}, body: mdText };

  const data = {};
  match[1].split("\n").forEach((line) => {
    const colonIdx = line.indexOf(":");
    if (colonIdx === -1) return;
    const key = line.slice(0, colonIdx).trim();
    const val = line.slice(colonIdx + 1).trim().replace(/^["']|["']$/g, "");
    data[key] = val;
  });

  return { data, body: mdText.slice(match[0].length).trim() };
};

export const FooterSummary = () => {
  const [text, setText] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await fetch(`/content/welcome-summary.md`);
        if (!res.ok) return;
        const mdText = await res.text();
        const { data } = parseFrontmatter(mdText);
        setText(data.abstract || "");
        setVisible(true);
      } catch {
        // non-critical — hide on error
      }
    };

    fetchSummary();
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.summary}>
      <p className={styles.text}>{text}</p>
    </div>
  );
};
